import CustomSweetAlert from '../common/customSweetAlert/CustomSweetAlert';
import {
  addProductToCart, deleteAssessmentDetail,
  deleteHWProfile,
  fetchAssessmentProducts,
  fetchAssessmentScore,
  fetchHnWAssessment,
  fetchHnWAssessmentDetail,
  fetchHnWAssessmentHistoryLog,
  fetchHnWAssessmentList,
  fetchPifCart,
  saveAssessmentAnswer,
  getChallenges,
  fetchTermsConditions,
  fetchSkinAssessmentResult,
  uploadAssessmentImage
} from '../services/healthWellness/healthWellness.service';
import { deleteHealthSpanProfile } from '../services/healthWellness/healthSpan.service';
import {
  GET_HNW_SCORE, FETCH_HNW_ASSESSMENT_LIST, FETCH_HNW_ASSESSMENT, UPDATE_HNW_ANSWER, DELETE_PROFILE_DATA, FETCH_HNW_ASSESSMENT_DETAIL,
  FETCH_HNW_ASSESSMENT_HISTORY_LOG, DELETE_HNW_ASSESSMENT_DETAIL, GET_HNW_PRODUCTS, FETCH_CUSTOMER_PIF_CART, ADD_PRODUCT, GET_BODYKEY_CHALLENGES,
  RESET_ASSESSMENT_SCORE,
  FETCH_TERMS_CONDITIONS,
  SAVE_SKIN_ASSESSMENT_ANSWERS,
  GET_SKIN_ASSESSMENT_RESULT,
  RESET_SKIN_ASSESSMENT_ANSWERS,
  GET_LAST_SAVED_ANSWERS
} from './types';

export const getHnWAssessmentList = (assessment_id) => (dispatch) =>
  fetchHnWAssessmentList(assessment_id)
    .then((result) => {
      dispatch({
        type: FETCH_HNW_ASSESSMENT_LIST,
        payload: result,
      });
      return result;
    })
    .catch(function (error) {
      CustomSweetAlert({
        title: "",
        text: error.message,
        confirmButtonText: "ตกลง",
      });
    });

export const getHnWAssessment = (assessment_id, params) => (dispatch) =>
  fetchHnWAssessment(assessment_id, params)
    .then((result) => {
      dispatch({
        type: FETCH_HNW_ASSESSMENT,
        payload: result,
      });
      return result;
    })
    .catch(function (error) {
      CustomSweetAlert({
        title: "",
        text: error.message,
        confirmButtonText: "ตกลง",
      });
    });

export const updateAssessmentAnswer =
  (assessment_id, assessment_data, answer_id, assessment_status, skinMetaData = {}) =>
    (dispatch) =>
      saveAssessmentAnswer(
        assessment_id,
        assessment_data,
        answer_id,
        assessment_status,
        skinMetaData
      )
        .then((result) => {
          if (result?.success) {
            dispatch({
              type: UPDATE_HNW_ANSWER,
              payload: result?.answerId,
              hasError: false,
            });
          } else {
            dispatch({
              type: UPDATE_HNW_ANSWER,
              payload: result?.errors,
              hasError: true,
            });
          }
          return result;
        })
        .catch(function (error) {
          CustomSweetAlert({
            title: "",
            text: error.message,
            confirmButtonText: "ตกลง",
          });
        });

export const getHnWAssessmentDetail = (assessment_id) => (dispatch) =>
  fetchHnWAssessmentDetail(assessment_id)
    .then((result) => {
      dispatch({
        type: FETCH_HNW_ASSESSMENT_DETAIL,
        payload: result,
      });
      return result;
    })
    .catch(function (error) {
      CustomSweetAlert({
        title: "",
        text: error.message,
        confirmButtonText: "ตกลง",
      });
    });

export const getHnWAssessmentHistoryLog = (assessmentId, customerId = null) => (dispatch) =>
  fetchHnWAssessmentHistoryLog(assessmentId, customerId)
    .then((result) => {
      dispatch({
        type: FETCH_HNW_ASSESSMENT_HISTORY_LOG,
        payload: result,
      });
      return result;
    })
    .catch(function (error) {
      CustomSweetAlert({
        title: "",
        text: error.message,
        confirmButtonText: "ตกลง",
      });
    });

export const deleteHnWAssessmentDetail = (answer_id) => (dispatch) =>
  deleteAssessmentDetail(answer_id)
    .then((result) => {
      dispatch({
        type: DELETE_HNW_ASSESSMENT_DETAIL,
        payload: result,
      });
      return result;
    })
    .catch(function (error) {
      CustomSweetAlert({
        title: "",
        text: error.message,
        confirmButtonText: "ตกลง",
      });
    });

export const getAssessmentScore = (assesmentAnswer) => (dispatch) =>
  fetchAssessmentScore(assesmentAnswer)
    .then((result) => {
      dispatch({
        type: GET_HNW_SCORE,
        payload: result,
      });
      return result;
    })
    .catch(function (error) {
      CustomSweetAlert({
        title: "",
        text: error.message,
        confirmButtonText: "ตกลง",
      });
    });

export const getAssessmentProducts = (type, productdIds, customerId = null) => (dispatch) =>
  fetchAssessmentProducts(productdIds, customerId)
    .then((result) => {
      dispatch({
        type: GET_HNW_PRODUCTS,
        payload: { type, result },
      });
      return result;
    })
    .catch(function (error) {
      CustomSweetAlert({
        title: "",
        text: error.message,
        confirmButtonText: "ตกลง",
      });
    });

export const getCartDetail = (fields) => (dispatch) =>
  fetchPifCart(fields)
    .then((result) => {
      dispatch({
        type: FETCH_CUSTOMER_PIF_CART,
        payload: result,
      });
      return result;
    })
    .catch(function (error) {
      CustomSweetAlert({
        title: "",
        text: error.message,
        confirmButtonText: "ตกลง",
      });
    });

export const addSelectedProductToCart = (cartId, product) => (dispatch) =>
  addProductToCart(cartId, product)
    .then((result) => {
      dispatch({
        type: ADD_PRODUCT,
        payload: result,
      });
      return result;
    })
    .catch(function (error) {
      console.log(error);
    });

export const deleteHWProfileData = () => (dispatch) =>
  Promise.all([deleteHWProfile(), deleteHealthSpanProfile()])
    .then(([result]) => {
      dispatch({
        type: DELETE_PROFILE_DATA,
        payload: result,
      });
      return result;
    })
    .catch(function (error) {
      CustomSweetAlert({
        title: '',
        text: error.message,
        confirmButtonText: 'ตกลง',
      });
    });

export const getBodyKeyChallengeDetail = (payload) =>
  (dispatch) => getChallenges(payload)
    .then(result => {
      dispatch({
        type: GET_BODYKEY_CHALLENGES,
        payload: result,
      });
      return result;
    })
    .catch(function (error) {
      console.log(error.message);
    });

export const resetAssessmentScore = () => dispatch => {
  dispatch({
    type: RESET_ASSESSMENT_SCORE
  })
}

export const getTermsConditions = (assessment_label) =>
  (dispatch) => fetchTermsConditions(assessment_label)
    .then(result => {
      dispatch({
        type: FETCH_TERMS_CONDITIONS,
        payload: result,
      });
      return result;
    })
    .catch(function (error) {
      console.log(error.message);
    });

export const saveSkinAssessmentAnswer = (payload) => dispatch => {
  dispatch({
    type: SAVE_SKIN_ASSESSMENT_ANSWERS,
    payload: payload,
  });
};

export const getSkinAssessmentResult = (id, payload) =>
  dispatch => fetchSkinAssessmentResult(id, payload)
    .then(res => {
      dispatch({
        type: GET_SKIN_ASSESSMENT_RESULT,
        payload: res
      })
    })

export const resetSkinAssessmentAnswers = (payload) => dispatch => {
  dispatch({
    type: RESET_SKIN_ASSESSMENT_ANSWERS,
    payload: payload,
  });
};

export const saveLastSavedAnswer = (payload) => dispatch => {
  dispatch({
    type: GET_LAST_SAVED_ANSWERS,
    payload: payload,
  });
};

export const getAssessmentImage = (file, assessment_label) =>
  dispatch => uploadAssessmentImage(file, assessment_label)
    .then(res => {
      dispatch({
        type: 'UPLOAD_ASSESSMENT_IMAGE',
        payload: res
      })
      return res;
    })

export const updateAssessmentProducts = (type, result) => dispatch => {
  dispatch({
    type: GET_HNW_PRODUCTS,
    payload: { type, result },
  });
}